import 'jquery';
import 'chosen-js';
import isTouchDev from './isTouchDev';
import _ from 'lodash';

/* eslint-disable no-unused-vars */

const municipalities = [
  { id: 1, name: 'Ånge' },
  { id: 2, name: 'Sollefteå' },
  { id: 3, name: 'Kramfors' },
  { id: 4, name: 'Örnsköldsvik' },
  { id: 5, name: 'Härnösand' },
  { id: 6, name: 'Timrå' },
  { id: 7, name: 'Sundsvall' },
  { id: 8, name: 'Bjurholm' },
  { id: 9, name: 'Strömsund' },
  { id: 10, name: 'Nordmaling' }
];

const sockens = [
  { id: 1, municipalityId: 7, name: 'Alnö' },
  { id: 2, municipalityId: 4, name: 'Anundsjö' },
  { id: 3, municipalityId: 4, name: 'Arnäs' },
  { id: 4, municipalityId: 7, name: 'Attmar' },
  { id: 5, municipalityId: 8, name: 'Bjurholm' },
  { id: 6, municipalityId: 3, name: 'Bjärtrå' },
  { id: 7, municipalityId: 4, name: 'Björna' },
  { id: 8, municipalityId: 9, name: 'Bodum' },
  { id: 9, municipalityId: 1, name: 'Borgsjö' },
  { id: 10, municipalityId: 2, name: 'Boteå' },
  { id: 11, municipalityId: 3, name: 'Dal' },
  { id: 12, municipalityId: 2, name: 'Ed' },
  { id: 13, municipalityId: 2, name: 'Edsele' },
  { id: 14, municipalityId: 9, name: 'Fjällsjö' },
  { id: 15, municipalityId: 4, name: 'Gideå' },
  { id: 16, municipalityId: 2, name: 'Graninge' },
  { id: 17, municipalityId: 4, name: 'Grundsunda' },
  { id: 18, municipalityId: 3, name: 'Gudmundrå' },
  { id: 19, municipalityId: 1, name: 'Haverö' },
  { id: 20, municipalityId: 2, name: 'Helgum' },
  { id: 21, municipalityId: 5, name: 'Hemsö' },
  { id: 22, municipalityId: 7, name: 'Holm' },
  { id: 23, municipalityId: 5, name: 'Häggdånger' },
  { id: 24, municipalityId: 6, name: 'Hässjö' },
  { id: 25, municipalityId: 5, name: 'Högsjö' },
  { id: 26, municipalityId: 7, name: 'Indal' },
  { id: 27, municipalityId: 2, name: 'Junsele' },
  { id: 28, municipalityId: 7, name: 'Liden' },
  { id: 29, municipalityId: 6, name: 'Ljustorp' },
  { id: 30, municipalityId: 2, name: 'Långsele' },
  { id: 31, municipalityId: 4, name: 'Mo' },
  { id: 32, municipalityId: 2, name: 'Multrå' },
  { id: 33, municipalityId: 7, name: 'Njurunda' },
  { id: 34, municipalityId: 3, name: 'Nora' },
  { id: 35, municipalityId: 3, name: 'Nordingrå' },
  { id: 36, municipalityId: 10, name: 'Nordmaling' },
  { id: 37, municipalityId: 4, name: 'Nätra' },
  { id: 38, municipalityId: 2, name: 'Ramsele' },
  { id: 39, municipalityId: 2, name: 'Resele' },
  { id: 40, municipalityId: 7, name: 'Selånger' },
  { id: 41, municipalityId: 4, name: 'Sidensjö' },
  { id: 42, municipalityId: 4, name: 'Själevad' },
  { id: 43, municipalityId: 3, name: 'Skog' },
  { id: 44, municipalityId: 4, name: 'Skorped' },
  { id: 45, municipalityId: 7, name: 'Skön' },
  { id: 46, municipalityId: 2, name: 'Sollefteå' },
  { id: 47, municipalityId: 5, name: 'Stigsjö' },
  { id: 48, municipalityId: 3, name: 'Styrnäs' },
  { id: 49, municipalityId: 7, name: 'Stöde' },
  { id: 50, municipalityId: 2, name: 'Sånga' },
  { id: 51, municipalityId: 5, name: 'Säbrå' },
  { id: 52, municipalityId: 7, name: 'Sättna' },
  { id: 53, municipalityId: 6, name: 'Timrå' },
  { id: 54, municipalityId: 1, name: 'Torp' },
  { id: 55, municipalityId: 3, name: 'Torsåker' },
  { id: 56, municipalityId: 4, name: 'Trehörningsjö' },
  { id: 57, municipalityId: 7, name: 'Tuna' },
  { id: 58, municipalityId: 6, name: 'Tynderö' },
  { id: 59, municipalityId: 9, name: 'Tåsjö' },
  { id: 60, municipalityId: 3, name: 'Ullånger' },
  { id: 61, municipalityId: 3, name: 'Vibyggerå' },
  { id: 62, municipalityId: 5, name: 'Viksjö' },
  { id: 63, municipalityId: 3, name: 'Ytterlännäs' },
  { id: 64, municipalityId: 2, name: 'Ådals-Liden' },
  { id: 65, municipalityId: 2, name: 'Överlännäs' }
];

class AccordionItem {
  constructor(title, titleClass) {
    this.title = title;
    this.parent = this.title.parent();
    this.contentBlock = this.parent.find('.info');
    this.titleClass = titleClass;
  }

  init() {
    if (this.title.hasClass('active')) {
      this.title.removeClass('active');
      this.contentBlock.slideUp();
    } else {
      this.title.addClass('active');
      this.contentBlock.slideDown();
      this.parent
        .siblings()
        .find(this.titleClass)
        .removeClass('active');
      this.parent
        .siblings()
        .find('.info')
        .slideUp();
    }
  }
}

class SearchForm {
  constructor($municipalitiesSelect, $sockensSelect, $objectTypesSelect) {
    this.$municipalitiesSelect = $municipalitiesSelect;
    this.$sockensSelect = $sockensSelect;
    this.$objectTypesSelect = $objectTypesSelect;
  }

  initSelects() {
    this._initMunicipalitiesSelect();
    this._initSockensSelect();
    this._initObjectTypesSelect();
  }

  selectMunicipality(val) {
    const municipalitiesFilter = municipalities.filter(municipality => municipality.name === val);
    let sockensInMunicipality = sockens;
    if (municipalitiesFilter.length) {
      sockensInMunicipality = sockens.filter(socken => socken.municipalityId === municipalitiesFilter[0].id);
    }
    this.$sockensSelect.empty().append('<option value="">Socken</option>');
    sockensInMunicipality.forEach(socken => {
      this.$sockensSelect.append(`<option value="${socken.name}">${socken.name}</option>`);
    });
    if (!isTouchDev()) {
      this.$sockensSelect.trigger('chosen:updated');
    }
  }

  setValues() {
    const uri = decodeURIComponent(window.location.href);
    const hashes = uri.slice(window.location.href.indexOf('?') + 1).split('&');
    let hash;
    if (hashes.length) {
      for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        switch (hash[0]) {
          case 'ort':
            this._setMunicipalityValue(hash[1]);
            break;
          case 'subregion':
            this._setSockenValue(hash[1]);
            break;
          case 'objekt_type':
            this._setObjectTypeValue(hash[1]);
            break;
          default:
            break;
        }
      }
    }
  }

  _setMunicipalityValue(val) {
    if (!isTouchDev()) {
      setTimeout(() => {
        this.$municipalitiesSelect.val(val).trigger('chosen:updated');
      }, 0);
    }
    this.selectMunicipality(val);
  }

  _setSockenValue(val) {
    if (!isTouchDev()) {
      setTimeout(() => {
        this.$sockensSelect.val(val).trigger('chosen:updated');
      }, 0);
    }
  }

  _setObjectTypeValue(val) {
    if (!isTouchDev()) {
      setTimeout(() => {
        this.$objectTypesSelect.val(val).trigger('chosen:updated');
      }, 0);
    }
  }

  _initMunicipalitiesSelect() {
    municipalities.forEach(municipality => {
      this.$municipalitiesSelect.append(`<option value="${municipality.name}">${municipality.name}</option>`);
    });
    if (!isTouchDev()) {
      this.$municipalitiesSelect.chosen({ disable_search: true });
    }
  }

  _initSockensSelect() {
    sockens.forEach(socken => {
      this.$sockensSelect.append(`<option value="${socken.name}">${socken.name}</option>`);
    });
    if (!isTouchDev()) {
      this.$sockensSelect.chosen({ disable_search: true });
    }
  }

  _initObjectTypesSelect() {
    if (!isTouchDev()) {
      this.$objectTypesSelect.chosen({ disable_search: true });
    }
  }
}

class PreviewImages {
  constructor(frame, options) {
    this.$hoverFrame = frame;
    this.options = options;
  }

  init() {
    const self = this;
    this.$previewImageFrame = this.$hoverFrame.find('.js-photo-block');
    this.$imagesList = this.$hoverFrame.find('.js-inner-slider-nav');
    this.$images = this.$imagesList.find('.js-inner-slide');
    this.$images.on('click', function() {
      self.$previewImageFrame.find('img').attr('src', $(this).attr('data-url'));
    });
  }

  destroy() {
    this.$previewImageFrame.find('img').attr('src', this.$images.eq(0).attr('data-url'));
  }
}

export default () => {
  /** search form **/
  const $municipalitiesSelect = $('.js-search-municipality');
  const $sockensSelect = $('.js-search-socken');
  const $objectTypesSelect = $('.js-search-type');
  const searchForm = new SearchForm($municipalitiesSelect, $sockensSelect, $objectTypesSelect);
  // search form init
  searchForm.initSelects();
  // search form change municipality
  $('body').on('change', '.js-search-municipality', function() {
    searchForm.selectMunicipality($(this).val());
  });

  let previewImages;

  $(document).on('click', '.js-search-item', function() {
    let $this = $(this);
    const $hoverBlock = $this.find('.js-search-hover-block');
    $hoverBlock.show();

    // init images preview
    if ($hoverBlock.hasClass('has-inner-slider')) {
      previewImages = new PreviewImages($hoverBlock);
      previewImages.init();
    }

    // checking PDF file existance
    if (
      ($hoverBlock.find('#_msword_div').length && !$hoverBlock.find('#_msword_div').find('a').length) ||
      ($hoverBlock.find('.pdf-download-link').length && !$hoverBlock.find('#_msword_div').length)
    ) {
      $hoverBlock
        .find('.pdf-download-link')
        .find('.not-available')
        .show();
    }

    $this
      .closest('.slick-slider')
      .find('.slick-arrow')
      .hide();
    $this.closest('.slick-slider').addClass('add-shadow');
  });

  $('.search-slider-nav').on('beforeChange', function() {
    let $this = $(this);
    const $hoverBlock = $this.siblings('.slick-slider').find('.js-search-hover-block');
    $hoverBlock.hide();
    $this.siblings('.slick-slider').removeClass('add-shadow');

    if ($hoverBlock.hasClass('has-inner-slider') && !_.isUndefined(previewImages)) {
      previewImages.destroy();
    }

    if ($this.hasClass('active')) {
      $this.removeClass('active');
    } else {
      $this.addClass('active');
    }
  });

  $(document).on('click', '.js-search-close-btn', function(e) {
    e.stopPropagation();
    let $this = $(this);

    const $hoverBlock = $this.closest('.js-search-hover-block');

    $hoverBlock.hide();

    if ($hoverBlock.hasClass('has-inner-slider') && !_.isUndefined(previewImages)) {
      previewImages.destroy();
    }

    $this
      .closest('.slick-slider')
      .find('.slick-arrow')
      .show();
    $this.closest('.slick-slider').removeClass('add-shadow');
  });

  $(document).on('click', '.js-document-title', function() {
    let accordionItem = new AccordionItem($(this), '.js-document-title');
    accordionItem.init();
  });

  $(document).on('click', '.js-audio-title', function() {
    let accordionItem = new AccordionItem($(this), '.js-audio-title');
    accordionItem.init();
  });

  $(document).ready(function() {
    let totalResults = 0;
    $('.js-summary').each(function() {
      totalResults += $(this).data('summary');
    });
    $('.js-total').html(totalResults);

    searchForm.setValues();

    $('.header')
      .find('.search-field')
      .attr('placeholder', 'Sök');

    let urlParams = "URLSearchParams" in window ? new URLSearchParams(window.location.search).get('soker'): '';

    $('.js-search-field').val(urlParams);

    if (
      $('.search-text-info')
        .text()
        .trim().length &&
      $('.search-ort-info')
        .text()
        .trim().length
    ) {
      $('.search-text-info').after('<span>/</span>');
    }
    if (
      $('.search-ort-info')
        .text()
        .trim().length &&
      $('.search-sub-info')
        .text()
        .trim().length
    ) {
      $('.search-ort-info').after('<span>/</span>');
    }
  });
};



// WEBPACK FOOTER //
// ./scripts/modules/search.js